import { render, staticRenderFns } from "./outerPerMgr.vue?vue&type=template&id=221d4927&scoped=true"
import script from "./outerPerMgr.vue?vue&type=script&lang=js"
export * from "./outerPerMgr.vue?vue&type=script&lang=js"
import style0 from "./outerPerMgr.vue?vue&type=style&index=0&id=221d4927&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d4927",
  null
  
)

export default component.exports